exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pagination .page-item.disabled .page-link{pointer-events:none;opacity:.5}.pagination .page-item.active .page-link{background-color:#0d6efd;border-color:#0d6efd;color:#fff}", ""]);

// exports
